export default {
  userLocation: state => state.userLocation,
  game: state => state.game,
  errorMessage: state => state.errorMessage,
  isUserAtChallengeLocation: state => state.isUserAtChallengeLocation,
  challengesLocations: state => state.challengesLocations,
  fingerprint: state => state.fingerprint,
  drawerState: state => state.drawerState,
  mapZoomState: state => state.mapZoom,
  mapCenterState: state => state.mapCenter,
  team: state => state.team,
  userScore: state => state.userScore,
  launchTutorial: state => state.launchTutorial,
  tutorialInProgress: state => state.tutorialInProgress,
  isLoggedIn: state => state.isLoggedIn,
  questionRadius: state => state.questionRadius,
  apiKey: state => state.apiKey,
  config: state => state.config,
  tenant: state => state.tenant,
}



// WEBPACK FOOTER //
// ./src/store/getters.js